import { render, staticRenderFns } from "./ParticipacaoAtividades.vue?vue&type=template&id=0fea11cc"
import script from "./ParticipacaoAtividades.vue?vue&type=script&lang=js"
export * from "./ParticipacaoAtividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports